// extracted by mini-css-extract-plugin
export default {"form":"styles_form__sIh66","forgot":"styles_forgot__SIJFB"};